import React, { useState } from 'react';
import '../../Rating.scss';

import { Col, Row, Slider } from 'antd';

import HappyFace from 'img/happyface.svg';
import UnhappyFace from 'img/unhappyface.svg';
import { SliderMarks } from 'antd/lib/slider';
import { RatingPropsNew } from 'components/Rating/types';

export interface SliderRatingProps
  extends Omit<RatingPropsNew, 'colorsForward' | 'id'> {
  min: number;
  max: number;
}

export const DEFAULT_BEFOREICON = <img src={UnhappyFace} />;
export const DEFAULT_AFTERICON = <img src={HappyFace} />;

export function SliderRating(props: SliderRatingProps) {
  const {
    min = 1,
    max = 5,
    beforeLabel = 'No pain',
    afterLabel = 'Unimaginable pain'
  } = props;
  const [cacheValue, setCacheValue] = useState(props.value);

  /**
   * Generate the tick marks of the slider
   *
   * From the antD documentation:
   *
   * > Tick marks of Slider. The type of key must be number, and must be in closed interval [min, max]. Each mark can declare its own style
   *
   */
  function generateSliderTickMarks(min: number, max: number): SliderMarks {
    const ret: SliderMarks = {};

    for (let i = min; i <= max; i++) {
      ret[i] = i;
    }

    return ret;
  }

  const onLocalValueChange = (e: React.SetStateAction<number | undefined>) =>
    setCacheValue(e);

  /**
   *
   * WARNING: This method is currently invoked through a deprecated API.
   * The `onAfterChangeComplete` callback may stop being invoked when AntD is upgraded
   */
  const onAfterChangeComplete = (e: number) => props.onChange?.(e);

  /*********
   * Resolve the order of the icons. The icons render in ascending order (before, after) when `iconsForward` is `true`.
   *********/
  /**
   * Resolved beforeIcon
   */
  const beforeIcon = props.iconsForward
    ? props.beforeIcon ?? DEFAULT_BEFOREICON
    : props.afterIcon ?? DEFAULT_AFTERICON;
  /**
   * Resolved afterIcon
   */
  const afterIcon = props.iconsForward
    ? props.afterIcon ?? DEFAULT_AFTERICON
    : props.beforeIcon ?? DEFAULT_BEFOREICON;

  return (
    <Row>
      <Col>
        <div style={{ marginTop: '0px' }}>
          <Row align="middle">
            {beforeIcon}
            {beforeLabel && (
              <span className="crx-circular-beforeLabel">{beforeLabel}</span>
            )}
            <div
              style={{
                position: 'relative',
                minWidth: '300px',
                fontFamily: 'Comfortaa',
                marginLeft: '46px',
                marginRight: '46px'
              }}
            >
              <Slider
                // dotStyle={{
                //   backgroundColor: 'rgba(118, 118, 121, 1)',
                //   height: '12px',
                //   width: '12px',
                //   top: '-4px'
                // }}
                railStyle={{ backgroundColor: 'rgba(228, 230, 235, 1)' }}
                trackStyle={{ backgroundColor: 'rgba(228, 230, 235, 1)' }}
                max={max}
                min={min}
                marks={generateSliderTickMarks(min, max)}
                defaultValue={min}
                // value={value}
                value={cacheValue}
                // onChange={onChange}
                onChange={onLocalValueChange}
                // 4.11+ antdesign
                onAfterChange={e => {
                  onAfterChangeComplete(e);
                }}
                disabled={props.disabled}
                step={1}
              />
            </div>
            {afterLabel && (
              <span className="crx-circular-afterLabel">{afterLabel}</span>
            )}
            {afterIcon}
          </Row>
          <span> </span>
        </div>
      </Col>
    </Row>
  );
}
